export default "__VITE_ASSET__3468d1c0__"